module.exports = __webpack_public_path__ + "static/img/nav_logo.e533bfdc.svg";